import React from 'react'

const ErrorShow = ({errorMsg}) => {
    return  errorMsg?<p style={{color:'red',textAlign:'left',fontSize:14}}>{"* "+errorMsg}</p>:null
}

export default ErrorShow
